import TemplateView from '../../../../TemplateView'
import {
    createNodesForCustomerList,
    createNodesForProjectList,
    createNodesForTaskList,
    entirelyAssignedCustomerTitle,
    entirelyAssignedProjectTitle,
    entirelyAssignedTaskTitle
} from "../utils"
import AssignmentsList from "./AssignmentsList"
import {HierarchyLevels} from "constants"
import messageResource from "../../../../messageResource"
import ScrollableContainer from "../../../../util/ScrollableContainer"
import TabContentHeader from "./TabContentHeader"
import EmptyList from './EmptyList'
import EntirelyAssignmentsBlock from './EntirelyAssignmentsBlock'
import {ALL_TABS_EMPTY_KEY} from '../constants'

export default class TabContent extends TemplateView {
    constructor({
        onEntityRevoked = () => {},
        onAllRevoked = () => {},
        onSearchChanged = () => {},
        onSearchToggled = () => {},
        setIsShowArchiveEntities = () => {},
        onEditButtonClick = () => {},
    }) {
        super()

        this.params = {
            onEntityRevoked,
            onAllRevoked,
            onSearchChanged,
            onSearchToggled,
            setIsShowArchiveEntities,
            onEditButtonClick,
        }

        this.state = {
            userFirstName: '',
            counters: {
                customers: {
                    curValue: 0,
                    maxValue: 0,
                },
                projects: {
                    curValue: 0,
                    maxValue: 0,
                },
                tasks: {
                    curValue: 0,
                    maxValue: 0,
                },
            },
            noCptAssignedToUserAtAll: false,

            searchString: '',
            searchOpen: false,

            entirelyAssignedTasksCounter: 0,
            entirelyAssignedProjectsCounter: 0,

            taskEntities: [],
            projectEntities: [],
            customerEntities: [],

            isShowArchivedEntities: false,
            showToggleArchivedButton: true,

            openTab: '',

            isWASEnabled: false,
        }

        this.onStatePropertyChanged('showToggleArchivedButton', (showToggleArchivedButton) => {
            this.header.setState({showToggleArchivedButton})
        })

        this.onStatePropertyChanged('counters', (counters) => {
            this.assignmentsLists[HierarchyLevels.PROJECT].setState({
                entirelyAssignedPrevLevel: counters.customers.curValue,
            })
            this.assignmentsLists[HierarchyLevels.TASK].setState({
                entirelyAssignedPrevLevel: counters.projects.curValue,
            })
        })

        this.onAnyStatePropertyChanged(['searchString', 'openTab'], ({searchString, openTab}) => {
            if (openTab)
                this.assignmentsLists[this.state.openTab].setState({searchText: searchString})

            this.header.setState({searchText: searchString})
        })

        this.onStatePropertyChanged('searchOpen', (searchOpen) => {
            this.header.setState({searchOpen})
        })

        this.onStatePropertyChanged('taskEntities', (entities) => {
            this.assignmentsLists[HierarchyLevels.TASK].setState({nodeEntities: entities})
            this.header.setState({revokeConfirmationText: this.getRevokeConfirmationText()})
            this._handleEmptyTab()
        })
        this.onStatePropertyChanged('projectEntities', (entities) => {
            this.assignmentsLists[HierarchyLevels.PROJECT].setState({nodeEntities: entities})
            this.header.setState({revokeConfirmationText: this.getRevokeConfirmationText()})
            this._handleEmptyTab()

        })
        this.onStatePropertyChanged('customerEntities', (entities) => {
            this.assignmentsLists[HierarchyLevels.CUSTOMER].setState({nodeEntities: entities})
            this.header.setState({revokeConfirmationText: this.getRevokeConfirmationText()})
            this._handleEmptyTab()
        })

        this.onStatePropertyChanged('entirelyAssignedTasksCounter', (taskCounter) => {
            this.assignmentsLists[HierarchyLevels.TASK].setState({
                entirelyAssignedCurrentLevel: taskCounter
            })
        })
        this.onStatePropertyChanged('entirelyAssignedProjectsCounter', (projectsCounter) => {
            this.assignmentsLists[HierarchyLevels.PROJECT].setState({
                entirelyAssignedCurrentLevel: projectsCounter
            })
        })

        this.onStatePropertyChanged('openTab', (tab) => {
            for (let tabName of Object.keys(this.assignmentsLists)) {
                this.assignmentsLists[tabName].toggle(tabName === tab)
            }

            if (tab) {
                this.assignmentsLists[tab].forceUpdate()
                this.assignmentsLists[tab].setState({isShowArchived: false})
            }

            this.header.setState({
                title: this.tabHeaderTitle(),
                hideArchivedButtonText: this._getHideMessage(tab),
                showArchivedButtonText: this._getShowMessage(tab),
                isShowArchivedEntities: false,
                revokeConfirmationText: this.getRevokeConfirmationText(),
            })

            this._handleEmptyTab()
        })

        this.onStatePropertyChanged('userFirstName', () => {
            this.header.setState({
                title: this.tabHeaderTitle(),
                revokeConfirmationText: this.getRevokeConfirmationText(),
            })
            this._setEmptyListTitles()
        })

        this.onStatePropertyChanged('isShowArchivedEntities', (value) => {
            this.header.setState({isShowArchivedEntities: value})

            if (this.state.openTab) {
                this.assignmentsLists[this.state.openTab].setState({isShowArchived: value})
            }
        })

        this.onStatePropertyChanged('isWASEnabled', () => {
            this.header.setState({
                revokeConfirmationText: this.getRevokeConfirmationText(),
            })
        })
    }

    templateHtml() {
        return '<div class="tabContent_assignments">' +
               '  <div class="header"/>' +
               '  <div class="entirelyAssignmentsBlockContainer"/>' +
               '  <div class="scrollableContentWrapper">' +
               '        <div class="scrollableContent"/>' +
               '  </div>' +
               '  <div class="emptyCptListContainer"></div>' +
               '</div>'
    }

    templateModel() {
        return {
            editAssignments: messageResource.getMessage('common.edit'),
        }
    }

    update() {
        if (this.state.openTab) {
            this.assignmentsLists[this.state.openTab].forceUpdate()
        }
    }

    afterRender() {
        this.$header = this.find(".header")
        this.header = new TabContentHeader({
            onClickToggleArchivedButton: this.params.setIsShowArchiveEntities,
            onAllRevoked: this.params.onAllRevoked,
            onSearchChanged: this.params.onSearchChanged,
            onSearchToggled: this.params.onSearchToggled,
        }).init(this.$header)

        const revokeMap = {
            [HierarchyLevels.CUSTOMER]: (id) => this.params.onEntityRevoked(HierarchyLevels.CUSTOMER, id),
            [HierarchyLevels.PROJECT]: (id) => this.params.onEntityRevoked(HierarchyLevels.PROJECT, id),
            [HierarchyLevels.TASK]: (id) => this.params.onEntityRevoked(HierarchyLevels.TASK, id),
        }

        this.$entirelyAssignmentsBlockContainer = this.find('.entirelyAssignmentsBlockContainer')
        this.entirelyAssignmentsBlock = new EntirelyAssignmentsBlock().init(this.$entirelyAssignmentsBlockContainer)

        this.$scrollableContent = this.find('.scrollableContent')
        this.$scrollableContentWrapper = this.find('.scrollableContentWrapper')

        this.assignmentsLists = {}

        this.assignmentsLists[HierarchyLevels.CUSTOMER] = this.createScrollableList({
                revokeMap: revokeMap,
                entirelyAssignedTitle: entirelyAssignedCustomerTitle,
                entirelyAssignedSubTitle: "",
                createNodesForList: createNodesForCustomerList,
                hierarchyLevel: HierarchyLevels.CUSTOMER,
        }).init(this.$scrollableContent)

        this.assignmentsLists[HierarchyLevels.PROJECT] = this.createScrollableList({
                revokeMap: revokeMap,
                entirelyAssignedTitle: entirelyAssignedProjectTitle,
                entirelyAssignedSubTitle: messageResource.getMessage('work_assignments.panel.projects.plus_selected'),
                createNodesForList: createNodesForProjectList,
                hierarchyLevel: HierarchyLevels.PROJECT,
        }).init(this.$scrollableContent)

        this.assignmentsLists[HierarchyLevels.TASK] = this.createScrollableList({
                revokeMap: revokeMap,
                entirelyAssignedTitle: entirelyAssignedTaskTitle,
                entirelyAssignedSubTitle: messageResource.getMessage('work_assignments.panel.tasks.plus_selected'),
                createNodesForList: createNodesForTaskList,
                hierarchyLevel: HierarchyLevels.TASK,
        }).init(this.$scrollableContent)

        this.$emptyList = this.find('.emptyCptListContainer')
        this.emptyList = new EmptyList({actionOnEmptyList: () => this.params.onEditButtonClick()}).init(this.$emptyList)
        this._setEmptyListTitles()
    }

    createScrollableList({revokeMap, entirelyAssignedTitle, entirelyAssignedSubTitle, createNodesForList, hierarchyLevel}) {
        return new ScrollableContainer(
            null,
            new AssignmentsList({
                revokeMap: revokeMap,
                entirelyAssignedTitle: entirelyAssignedTitle,
                entirelyAssignedSubTitle: entirelyAssignedSubTitle,
                createNodesForList: createNodesForList,
                hierarchyLevel: hierarchyLevel,
            }),
            {
                containerClass: "scrollableList"
            }
        )
    }

    _handleEmptyTab() {
        const openTab = this.state.openTab
        let listIsEmpty = false
        let entirelyAssignedText = ""
        let plusSelectedText = ""
        let canRevoke = true
        if (openTab === HierarchyLevels.TASK) {
            listIsEmpty = this.state.taskEntities.length === 0
            entirelyAssignedText = entirelyAssignedTaskTitle(this.state.entirelyAssignedTasksCounter, this.state.counters.projects.curValue)
            plusSelectedText = messageResource.getMessage('work_assignments.panel.tasks.plus_selected')
            canRevoke = this._containsRevokableEntities({entities: this.state.taskEntities, type: HierarchyLevels.TASK})
        } else if (openTab === HierarchyLevels.PROJECT) {
            listIsEmpty = this.state.projectEntities.length === 0
            entirelyAssignedText = entirelyAssignedProjectTitle(this.state.entirelyAssignedProjectsCounter, this.state.counters.customers.curValue)
            plusSelectedText = messageResource.getMessage('work_assignments.panel.projects.plus_selected')
            canRevoke = this._containsRevokableEntities({entities: this.state.projectEntities, type: HierarchyLevels.PROJECT})
        } else if (openTab === HierarchyLevels.CUSTOMER) {
            listIsEmpty = this.state.customerEntities.length === 0
            canRevoke = this._containsRevokableEntities({entities: this.state.customerEntities, type: HierarchyLevels.CUSTOMER})
        }

        const isSearchResult = this.state.searchOpen
        const showEmptyListView = listIsEmpty && !isSearchResult
        const assignmentsFromTopLevel = !!entirelyAssignedText
        const allCountersZero = this.state.counters.tasks.curValue === 0
                                && this.state.counters.projects.curValue === 0
                                && this.state.counters.customers.curValue === 0

        this.$emptyList.toggle(showEmptyListView)
        const noWorkScopeWarningText = this.state.noCptAssignedToUserAtAll ?
                                       messageResource.getMessage('work_assignments.empty_list.no_work', [this.state.userFirstName]) : ""
        this.emptyList.setState({
            openTabKey: allCountersZero ? ALL_TABS_EMPTY_KEY : openTab,
            isNoSelectedTitle: assignmentsFromTopLevel,
            isAssignMoreSubtitle: assignmentsFromTopLevel,
            withBorderAndBackground: !assignmentsFromTopLevel,
            noWorkScopeWarningText: noWorkScopeWarningText,
        })
        this.entirelyAssignmentsBlock.setState({
            title: entirelyAssignedText,
            plusSelectedItemsText: plusSelectedText,
        })
        this.$entirelyAssignmentsBlockContainer.toggle(showEmptyListView && assignmentsFromTopLevel)
        this.$scrollableContentWrapper.toggle(!showEmptyListView)
        this.$header.toggle(!showEmptyListView || assignmentsFromTopLevel)
        this.header.setState({
            searchDisabled: showEmptyListView,
            revokeDisabled: showEmptyListView || !canRevoke,
        })

        this.update()
    }

    _containsRevokableEntities({entities, type}) {
        return entities.some(entity => entity.type === type && entity.revokeEnabled)
    }

    _getHideMessage(tab) {
        if (tab === HierarchyLevels.TASK) {
            return messageResource.getMessage("management_assignment.hide_completed")
        }

        return messageResource.getMessage("management_assignment.hide_archived")
    }

    _getShowMessage(tab) {
        if (tab === HierarchyLevels.TASK) {
            return messageResource.getMessage("management_assignment.show_completed")
        }

        return messageResource.getMessage("management_assignment.show_archived")
    }

    tabHeaderTitle() {
        //abstract
    }

    getRevokeConfirmationText() {
        //abstract
    }

    _setEmptyListTitles() {
        //abstract
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsPanelTab/components/TabContent.js